import React from "react";
import {
  AutocompleteInput,
  EditProps,
  FormDataConsumer,
  ReferenceInput,
  required,
  SimpleForm,
  Toolbar,
  useEditController,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import CustomWaveInput from "../../components/CustomWaveInput";
import CustomRouteInput from "../../components/CustomRouteInput";
import SanitizedGrid from "../../components/SanitizedGrid";
import SaveButtonSubcontractorAdjustmentPrice from "./components/SaveButtonSubcontractorAdjustmentPrice";
import EditWrapper from "../../components/EditWrapper";
import PermissionLoading from "../../components/PermissionLoading";
import RoutePriceComponent from "./components/RoutePriceComponent";
import CustomNumberInput from "../../components/CustomNumberInput";
import Alert from "@material-ui/lab/Alert";

const CustomToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButtonSubcontractorAdjustmentPrice formInvalid={props.invalid} />
    </Toolbar>
  );
};

const SubcontractorAdjustmentPriceEdit = (props: EditProps) => {
  const { id } = props;
  const param = GetParam();
  const { record, loading } = useEditController(props);

  const breadcrumb = [
    {
      title: "Subcontractors",
      link: `/subcontractors/${param.get("subcontractorId")}/show`,
    },
    {
      title: "Financial",
      link: `/subcontractors/${param.get("subcontractorId")}/show/2`,
    },
    {
      title: id,
      link: "",
    },
  ];

  const formatRecord = (res: any) => {
    if (res) {
      if (res.price) {
        res.amount = res.price / 100;
      }

      return res;
    }
  };

  if (loading) {
    return <PermissionLoading />;
  }

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        isDefaultTitle
        actions={null}
        {...props}
      >
        <SimpleForm
          record={formatRecord(record)}
          toolbar={
            <CustomToolbar
              redirectLink={`/subcontractors/${param.get(
                "subcontractorId",
              )}/show/2`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">General Info</Typography>
            </Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="Subcontractor"
                source="subcontractorId"
                reference="subcontractors"
                validate={required()}
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <ReferenceInput
                label="School"
                source="schoolId"
                reference="schools"
                validate={required()}
                filterToQuery={(searchText: any) => {
                  if (searchText !== "") return { search: searchText };
                }}
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomWaveInput isDisable isEdit isRequired />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Adjustment Price Detail</Typography>
            </Grid>

            <Grid item xs={4}>
              <CustomRouteInput source="routeId" isDisable isEdit isRequired />
            </Grid>
            <Grid item xs={8}></Grid>

            <Grid item xs={4}>
              <CustomNumberInput label="Price ($)" source="amount" isRequired />

              <Alert severity="info" style={{ marginTop: "-20px", marginBottom: "25px" }}>
                By default, the price entered is considered a positive value.
                <br/>
                If you want to create a negative value, please prefix
                the price with a minus sign (e.g., <strong>-100</strong>).
              </Alert>

              <FormDataConsumer>
                {({ formData }) => {
                  return (
                    <RoutePriceComponent
                      routeId={formData?.routeId}
                      subcontractorId={formData?.subcontractorId}
                      schoolId={formData?.schoolId}
                      price={Number(formData?.amount)}
                    />
                  );
                }}
              </FormDataConsumer>
            </Grid>
            <Grid item xs={8}></Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default SubcontractorAdjustmentPriceEdit;
